import { useEffect } from 'react';

export const useGoogleAutocompleteNoTranslate = (googleAPILoaded: boolean) => {
  useEffect(() => {
    if (!googleAPILoaded) return;

    const addNoTranslate = () => {
      document.querySelectorAll('.pac-item').forEach((el) => {
        el.classList.add('notranslate');
      });
    };

    const observer = new MutationObserver(() => {
      addNoTranslate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer?.disconnect();
  }, [googleAPILoaded]);
};